export class AsxEquityUtil {

    private static readonly Gold = "GOLD";

    public static isEquity(code: string): boolean {
        return code.length === 3 || AsxEquityUtil.Gold === code;
    }
}